import { useLocalStorage } from '@/hooks/use-local-storage';
import { useCallback } from 'react';

export type TimelineDateMode = 'relative' | 'absolute' | 'delta';

const STORAGE_KEY = 'timeline-date-mode';
const MODE_CYCLE: TimelineDateMode[] = ['relative', 'absolute', 'delta'];

// TODO: move timelinedatamode setting to synced users settings (packages/user-settings)

/**
 * Hook for managing the timeline date display mode.
 * The mode is persisted in localStorage and shared across all timeline instances.
 *
 * Modes:
 * - `relative` — "2 hours ago", "3 days ago"
 * - `absolute` — "14:32" (today) or "Apr 15, 14:32" (other days)
 * - `delta`    — "+12m", "+3h" (time elapsed since the previous event)
 */
export function useTimelineDateMode() {
  const [mode, setMode] = useLocalStorage<TimelineDateMode>(
    STORAGE_KEY,
    'relative',
  );

  const cycleMode = useCallback(() => {
    setMode((current) => {
      const idx = MODE_CYCLE.indexOf(current);
      return MODE_CYCLE[(idx + 1) % MODE_CYCLE.length];
    });
  }, [setMode]);

  return { mode, cycleMode } as const;
}
